module.exports = __webpack_public_path__ + "media/images/pic/brodno/cambridge-prepare-772e7be9d4551d0b58630bb1caa6f690.png";